export const ASC_SORT_ORDER = 'ASC'
export const DESC_SORT_ORDER = 'DESC'
export const defaultSortOrder = ASC_SORT_ORDER
